import { render, staticRenderFns } from "./form-presentation.vue?vue&type=template&id=f2ea5892&"
import script from "./form-presentation.vue?vue&type=script&lang=js&"
export * from "./form-presentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports